import CountUp from "react-countup";
import { motion } from "framer-motion";
import { reveal } from "@/lib/motion";

const stats = [
  { end: 99.4, suffix: "%", decimals: 1, label: "On-Time Delivery" },
  { end: 12500, suffix: "+", decimals: 0, label: "Vetted Carriers" },
  { end: 48, suffix: "", decimals: 0, label: "States Covered" },
  { end: 24, suffix: "/7", decimals: 0, label: "Live Dispatch" },
];

export const Stats = () => {
  return (
    <section id="stats" className="relative z-10 border-y border-white/10 bg-ink py-24" data-testid="stats">
      <div className="mx-auto grid max-w-[1500px] grid-cols-2 gap-y-14 px-6 lg:grid-cols-4 lg:px-12">
        {stats.map((s, i) => (
          <motion.div
            key={s.label}
            {...reveal}
            transition={{ ...reveal.transition, delay: i * 0.1 }}
            className="border-l border-white/10 pl-6"
            data-testid={`stat-${i}`}
          >
            <div className="font-display text-5xl font-bold text-white md:text-6xl lg:text-7xl">
              <CountUp end={s.end} suffix={s.suffix} decimals={s.decimals} duration={2.4} enableScrollSpy scrollSpyOnce />
            </div>
            <div className="mt-3 font-mono text-xs uppercase tracking-[0.2em] text-neon">{s.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
